export default function remove_id_from_list(id, list) {
  list.splice(
    list.findIndex((list_id) => list_id === id),
    1,
  );
  return list;
}
